import Crud from '../views/ChecklistSchedule/Crud'
import Add from '../views/ChecklistSchedule/Add'

let routes = {
    path: '/checklistschedules',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/checklistschedules',
            name: 'list-checklistschedules',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Agendamentos',
                breadcrumb: [
                    {
                        text: 'Agendamentos',
                        active: true,
                    },
                ],
                perfil_id: ['1', '6', '7'] // Apenas administradores e gestores
            },
        },
        {
            path: '/checklistschedules/add',
            name: 'add-checklistschedule',
            component: Add,
            meta: {
                pageTitle: 'Adicionar Agendamento',
                breadcrumb: [
                    {
                        text: 'Agendamentos',
                        to: '/checklistschedules',
                    },
                    {
                        text: 'Adicionar',
                        active: true,
                    },
                ],
                perfil_id: ['1', '6', '7'] // Apenas administradores e gestores
            },
        },
        {
            path: '/checklistschedules/edit/:id',
            name: 'edit-checklistschedule',
            component: Add,
            meta: {
                pageTitle: 'Editar Agendamento',
                breadcrumb: [
                    {
                        text: 'Agendamentos',
                        to: '/checklistschedules',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    },
                ],
                perfil_id: ['1', '6', '7'] // Apenas administradores e gestores
            },
        },
    ]
};


export default routes
